/**
 * 群组信息
 * Bai.Zhiming
 * 2019-7-23
 */
angular.module("imGroupInfoModule", []).
controller("imGroupInfoCtrl", ['groupInfo', '$scope', '$modalInstance', function(groupInfo, $scope, $modalInstance) {
    initStatus();
    /**
     * [confirm description] 确认
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        $modalInstance.close(angular.copy($scope.data));
    };
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.data = {
            groupName: groupInfo.name,
            groupImage: groupInfo.groupImage,
            Introduction: groupInfo.Introduction,
            Notification: groupInfo.Notification
        };
    }
}]);